'use strict';

$(function () {

    $("body").on("change", ".link_selector", function () {
        if ($(this).val() === "external_link") {
            let link = prompt("Enter the full URL for the external link:\n\nExample: https://example.com\n\nMake sure to include http:// or https://");
            if (link != null && link.trim() !== "") {
                let url = link.trim();
                if (!url.match(/^https?:\/\//i)) {
                    url = "https://" + url;
                }
                $(this).append('<option value="' + url + '">External Link (' + url + ')</option>');
                $(this).val(url);
            } else if (link === "") {
                $(this).val($(this).find('option:first').val() || "");
            }
        }
    });

    if ($(".resource-selector").length) {

        function reloadResourceList($selector, html) {
            $(".loader", $selector).hide();
            $(".content", $selector).html(html);

            let currentId = $selector.prev("input").val();
            if (!currentId) { return; }

            let $active = $(".resource[data-resource='" + currentId + "']", $selector).first();
            if (!$active.length) {
                return;
            }

            $(".resource.is-active", $selector).removeClass("is-active");
            $active.addClass("is-active");

            let containerTop = $selector.offset().top;
            let itemTop = $active.offset().top;
            let delta = itemTop - containerTop - 8; // small offset
            $selector.scrollTop($selector.scrollTop() + delta);
        }

        $("body").on("click", ".resource-selector .folder", function (e) {
            e.preventDefault();

            let $selector = $(this).closest(".resource-selector");

            $(".loader", $selector).show();
            $(".content", $selector).empty();

            $.get($(this).prop("href"), function (html) {
                reloadResourceList($selector, html);
            });
        });

        $("body").on("click", ".resource-selector .resource", function (e) {
            e.preventDefault();

            let $selector = $(this).closest(".resource-selector");
            let $button = $("button", $selector.parent());

            $(".resource.is-active", $selector).removeClass("is-active");
            $(this).addClass("is-active");

            let markdownResource = $(this).closest(".WellMediaMarkdown");

            if (markdownResource.length === 1) {
                $button.attr("data-path", $(this).data("path") || "");
                $button.attr("data-alt", $(this).data("alt") || "");
            } else {
                let value = $(this).data("resource") || "";
                $selector.prev("input").val(value);
            }
        });

        $(".resource-selector").each(function () {
            let $selector = $(this);
            let currentId = $selector.prev("input").val() || "";

            $(".loader", $selector).show();

            $.get("/alaska/resources/", { d: currentId }, function (html) {
                reloadResourceList($selector, html);
            });
        });
    }

});